import { Tween, Easing } from '@tweenjs/tween.js';
import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import TransformComponent from '../../../Component/Transform';
import CardComponent from '../../../Component/Level/Card';

export class CardWiggle extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        const transform: TransformComponent = gameObject.getComponent(
            TransformComponent
        );
        const cardComponent = gameObject.getComponent(CardComponent);

        const delay: number = 75;
        const rot1 = cardComponent.rotation + Math.PI * 0.05;
        const rot2 = cardComponent.rotation - Math.PI * 0.05;
        const rotT = cardComponent.rotation;

        const tween: Tween = this.getTween(transform);
        tween.easing(Easing.Quadratic.InOut);

        yield* this.tweenTo(tween, rot2, delay);
        yield* this.tweenTo(tween, rot1, delay);
        yield* this.tweenTo(tween, rot2, delay);
        yield* this.tweenTo(tween, rot1, delay);
        yield* this.tweenTo(tween, rot2, delay);
        yield* this.tweenTo(tween, rot1, delay);
        yield* this.tweenTo(tween, rotT, delay);
    }

    private *tweenTo(
        tween: Tween,
        rotation: number,
        delay: number
    ): IterableIterator<number> {
        tween.to({ rotation: rotation }, delay);
        yield* this.startTween(tween);
    }
}
